import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Company } from 'src/model/company.model';
import { User } from 'src/model/user.model';
import { CompanyService } from 'src/services/company.service';

@Component({
    selector: 'app-add-account',
    templateUrl: './add-account.component.html',
    styleUrls: ['./add-account.component.scss'],
    standalone: false
})
export class AddAccountComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApiAddress = inject(ConstructAPI);
  private enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private companyService = inject(CompanyService);

  selectedCompany = "COMPANY";
  selectedCompanyID: number;

  selectedUsername = "";

  @Input() accountNo: string;
  @Input() holderName: string;
  @Input() accountName: string;
  @Input() initialAmount = 0;
  @Input() initialAccountDate: Date;
  @Input() accountId: number;
  @Input() isCashAccount = false;

  companyList: Company[] = [];
  userList: User[] = [];

  accountNoNull = false;
  holderNameNull = false;
  accountNameNull = false;
  selectedCompanyNull = false;
  selectedUsernameNull = false;

  disabledSubmit = false;

  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    const isStaff = this.checkIsStaff();

    // if (isStaff) {
    //   //push STAFF COMPANY
    //   var companyId = Number(sessionStorage.getItem('companyId'));
    //   var companyName = sessionStorage.getItem('companyName');

    //   this.companyList.push(new Company(companyId, companyName, null, null, null));

    //   this.selectedCompanyID = companyId;

    //   //push STAFF USERNAME
    //   var username = sessionStorage.getItem('username');
    //   this.userList.push(new User(null, companyId, companyName, null, null, username, null));
    //   this.selectedUsername = username;

    // }
    // else {
    const companyId = Number(sessionStorage.getItem('companyId'));

    if (this.isBranchManager())
      this.selectedCompanyID = companyId;
    else
      this.getAllCompanies();
  }

  private async getAllCompanies() {
    this.companyList = await this.companyService.getAllCompanies();
  }

  checkIsStaff() {
    const roleID = Number(sessionStorage.getItem('roleId'));
    if (roleID === this.enums.STAFF)
      return true
    else
      return false
  }

  setSelectedCompany(companyID: number) {
    if (companyID === this.selectedCompanyID)
      return true
    else
      return false;
  }

  setSelectedUser(username: string) {
    if (username === this.selectedUsername)
      return true
    else
      return false;
  }

  validField(field: string) {
    switch (field) {
      case 'accountNo': this.accountNoNull = (this.accountNo === ''); break;
      case 'holderName': this.holderNameNull = (this.holderName === ''); break;
      case 'accountName': this.accountNameNull = (this.accountName === ''); break;
      case 'selectedCompany': this.selectedCompanyNull = (this.selectedCompany === ''); break;
      case 'selectedUsername': this.selectedUsernameNull = (this.selectedUsername === ''); break;
    }
  }

  fieldIncomplete() {
    this.accountNoNull = ((this.accountNo == undefined || this.accountNo === ''));
    this.holderNameNull = (this.holderName == undefined || this.holderName === '');
    this.accountNameNull = (this.accountName == undefined || this.accountName === '');
    this.selectedCompanyNull = (!this.selectedCompany || this.selectedCompany === '');
    this.selectedUsernameNull = (!this.selectedUsername || this.selectedUsername === '');
    const amountInvalid = (isNaN(+this.initialAmount))
    const initialAmountNull = (this.initialAmount == undefined);
    const initialAccountDateNull = (this.initialAccountDate == undefined)

    if (this.accountId == undefined)
      return (this.accountNoNull || this.holderNameNull || this.accountNameNull ||
        this.selectedCompanyNull || initialAmountNull || initialAccountDateNull || amountInvalid);

    else {
      if (this.isCashAccount == true)

        return (this.accountNameNull);
      else
        return (this.accountNoNull || this.holderNameNull || this.accountNameNull);
    }
  }

  addNewAccount() {
    // var xhr = new XMLHttpRequest();
    // var url = "http://localhost:10080/api/v1/account";
    // xhr.open("POST", url, true);
    // xhr.setRequestHeader("Content-type", "application/json");
    // xhr.withCredentials = true;
    this.disabledSubmit = true;

    if (this.initialAccountDate != undefined)
      //in order to get the correct result, end date need to add 1 day and minus 1 millisecond
      // 3600*1000*24 is 1 day in millisecond, then reduced by 1 millisecond
      var reduceASecDate = new Date(Number(this.initialAccountDate) - 1);

    const initialCashBookDateStr = (this.initialAccountDate == undefined) ? undefined : reduceASecDate.toISOString();

    const data = {
      "number": this.accountNo,
      "name": this.accountName,
      "companyId": Number(this.selectedCompanyID),
      "holderName": this.holderName,
      "initialAccountBalance": Number(this.initialAmount),
      "initialAccountDate": initialCashBookDateStr,
      "username": this.selectedUsername
    };

    const xhr = (this.accountId == undefined)
      ? this.restapi.postRequest(this.constructApiAddress.getAddAcccount(), data)
      : this.restapi.putRequest(this.constructApiAddress.getAccount(this.accountId), data)
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          this.disabledSubmit = false;
          const json = JSON.parse(xhr.responseText);

          const account = new Account(json.id, json.number, json.name, json.holderName, this.initialAmount, json.companyId, null);
          this.reset();

          if (this.accountId == undefined) {
            this.passEntry.emit(account);
            this.sharedService.openAlert("Successfully added account!", ALERT_TYPE.SUCCESS);
          }
          else {
            window.location.reload();
          }
        } else {
          this.disabledSubmit = false;
          this.sharedService.openAlert("Some error occurs, please try again later", ALERT_TYPE.DANGER);
        }
      }
    }
  }

  isBranchManager() {
    const role = Number(sessionStorage.getItem('roleId'));
    if (role == this.enums.BRANCH_MANAGER)
      return true;

    else return false;
  }

  submit() { this.fieldIncomplete() ? this.sharedService.openAlert('Please fill in all the fields!', ALERT_TYPE.DANGER) : this.addNewAccount(); }

  reset() {
    this.activeModal.close();
    this.accountNo = "";
    this.accountName = "";
    this.holderName = "";
    this.companyList.splice(0, this.companyList.length);
    this.userList.splice(0, this.userList.length);
    this.selectedCompanyID = 0;
    this.selectedUsername = "";
  }
}
